// src/api/enFabrication.api.ts — SCE Issues
// Lecture et écriture de la liste des équipements en fabrication (05/10) :
// bloc `enFabrication` de la ligne `__global__` de SCE_UserPrefs, à côté des
// couleurs métier et des modèles mémorisés. Aucune colonne SharePoint.
// Règles et format : `utils/enFabrication`.

import { lireBlocGlobal, modifierBlocGlobal } from './reglagesGlobaux.api'
import {
  VERSION_EN_FABRICATION,
  lireListeEnFabrication,
  type ListeEnFabrication,
} from '@/utils/enFabrication'

const BLOC_EN_FABRICATION = 'enFabrication'

export async function lireEnFabrication(): Promise<ListeEnFabrication | null> {
  return lireListeEnFabrication(await lireBlocGlobal(BLOC_EN_FABRICATION))
}

/** Remplace la liste entière : c'est l'état du dossier de production à cet instant. */
export async function enregistrerEnFabrication(numerosSerie: readonly string[], par: string): Promise<ListeEnFabrication> {
  const liste: ListeEnFabrication = {
    version: VERSION_EN_FABRICATION,
    numerosSerie: [...numerosSerie],
    le: new Date().toISOString(),
    par,
  }
  await modifierBlocGlobal(BLOC_EN_FABRICATION, () => liste)
  return liste
}
